import { useTranslation } from 'react-i18next';
import ErrorBoundary from 'src/components/ErrorBoundary';
import Navbar from 'src/components/NavBar';
import useWindowSize from 'src/hooks/useWindowSize';
import CopyShoppingListSidePanelContainer from 'src/sections/view_shopping_lists/CopyShoppingListSidePanelContainer';
import CreateShoppingListSidePanelContainer from 'src/sections/view_shopping_lists/CreateShoppingListSidePanelContainer';
import EditShoppingListSidePanelContainer from 'src/sections/view_shopping_lists/EditShoppingListSidePanelContainer';
import ShareShoppingListSidePanelContainer from 'src/sections/view_shopping_lists/ShareShoppingListSidePanelContainer';
import { ViewShoppingListsContextProvider } from 'src/sections/view_shopping_lists/ViewShoppingListsContext';
import ViewShoppingListsGridView from 'src/sections/view_shopping_lists/ViewShoppingListsGridView';
import ViewShoppingListsHeader from 'src/sections/view_shopping_lists/ViewShoppingListsHeader';
import 'src/style/grid/grid-override.scss';
import 'src/style/select-company/SelectCompany.scss';
import 'src/style/view-shopping-lists/ViewShoppingLists.scss';

const ViewShoppingLists = () => {
  const { t } = useTranslation();
  const { height } = useWindowSize();

  return (
    <ErrorBoundary>
      <ViewShoppingListsContextProvider>
        <div
          data-testid="view-shopping-lists-page"
          className="view-shopping-lists-layout"
          style={{ height: `${height}px` }}
        >
          <div className="mb-2 min-h-0 bg-white" style={{ gridArea: 'navbar' }}>
            <Navbar title={t('View and Edit Lists')} />
            <ViewShoppingListsHeader />
          </div>
          <div
            className="flex h-full min-h-0 w-full flex-col overflow-hidden"
            style={{ gridArea: 'main' }}
          >
            <ViewShoppingListsGridView />
          </div>
          <CreateShoppingListSidePanelContainer />
          <EditShoppingListSidePanelContainer />
          <ShareShoppingListSidePanelContainer />
          <CopyShoppingListSidePanelContainer />
        </div>
      </ViewShoppingListsContextProvider>
    </ErrorBoundary>
  );
};

export default ViewShoppingLists;
